import {
    GlobalLoading,
    WidgetLoading,
    ApplicationLoading,
    LoadingAnimationContainer
} from "./loading-containers";
import Preloader from "@tinqin/tinqin-ui-components/src/preloader/Preloader";
import { ScrollLoading } from "./container";
import BaseComponent from "./base";
import PreloaderTypes from "./loading-containers/PreloaderTypes";
import { WidgetContainer } from "./widget-container";
import WidgetDashboard from "../app/WidgetDashboard";

//exports a dictionary of components to be available initially
//example: widget should be able to render default widget loading on startup
export const initialComponents = {
    preloaderTypes: PreloaderTypes,
    globalLoading: GlobalLoading,
    widgetLoading: WidgetLoading,
    googleMapLoading: WidgetLoading,
    applicationLoading: ApplicationLoading,
    loadingAnimationContainer: LoadingAnimationContainer,
    scrollLoading: ScrollLoading,
    preloader: Preloader,
    base: BaseComponent,
    widget: WidgetContainer,
    widgetContainer: WidgetDashboard
};
